<template>
  <div style="margin-right: 5rem">
    <div class="row">
      <div class="col-3">
        <div>
          <span class="text-danger">* </span>
          <label class="form-label">{{this.$t('base.type')}}</label>
        </div>
        <Multiselect
          v-model="parentNode.type"
          :close-on-select="true"
          :searchable="true"
          :canClear="false"
          :placeholder="this.$t('page.pleaseSelectType')"
          :options="typeOptions"
          :disabled="isDisabled"
          style="height: 40px"
          @change="handlerChange"
        />
      </div>
      <div class="col-3">
        <div>
          <span class="text-danger">* </span>
          <label class="form-label">{{this.$t('page.product-info.name')}}</label>
        </div>
        <el-cascader
          :class="[submitted && parentNode.node.length <= 0 && 'is-invalid']"
          ref="cascaderPanelRef"
          style="width: 100%"
          v-model="parentNode.node"
          :options="options"
          :props="setProps"
          :show-all-levels="true"
          :clearable="false"
          :size="'large'"
          :filterable="true"
          :disabled="isDisabled"
          @change="parentNodeChange"
          :placeholder="this.$t('page.product-info.select')"
        />
        <div
          v-show="submitted && parentNode.node.length <= 0"
          class="invalid-feedback"
        >
          <span>{{ validationTips.parentNotNull }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getModelList } from "@/service/index";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import "@/default.scss";
import _ from "lodash";
export default {
  emits: ["update:parentInfo"],
  props: {
    submitted: Boolean,
    validationTips: Object,
    parentInfo: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    parentNode: {
      handler(val) {
        if (val) {
          console.log("2", val);
          this.$emit("update:parentInfo", val);
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      typeOptions: [
        {
          label: this.$t('page.work-order.device.single'),
          value: 1,
        },
        {
          label: this.$t('page.work-order.device.unit_type'),
          value: 2,
        },
      ],
      parentNode: {
        type: _.get(this.$route, ["query", "current_type"]) || "",
        node: [],
      },
      setProps: {
        checkStrictly: true,
        expandTrigger: "hover",
        value: "id",
        label: "name",
      },
      options: [
        {
          id: null,
          name: this.$t('page.no'),
        },
      ],
      isDisabled: false,
      optionVisible: false,
    };
  },
  mounted() {
    let parents =
      (sessionStorage.getItem("parentNodes") &&
        JSON.parse(sessionStorage.getItem("parentNodes"))) ||
      [];

    this.isDisabled = _.get(this.$route, ["query", "type"]) != "create";
    if (_.get(this.$route, ["query", "type"]) == "edit") {
      if (parents.length <= 1) {
        this.parentNode.node = parents;
      } else {
        this.parentNode.node = parents[parents.length - 2];
      }
    } else {
      this.parentNode.node = parents;
    }
    let type = _.get(this.$route, ["query", "current_type"]);

    this.initModelList(type);
  },
  methods: {
    parentNodeChange() {
      this.$refs.cascaderPanelRef.togglePopperVisible();
    },
    handlerChange(value) {
      if (this.parentNode.type != value) {
        this.parentNode.node = []
      }

      this.parentNode.type = value;
      this.initModelList(value);
    },
    initModelList(type) {
      getModelList({ type: type }).then((res) => {
        if (res && res.payload && res.payload.data) {
          this.options = [
            {
              id: null,
              name: this.$t('page.no'),
            },
          ];
          this.options.unshift(...res.payload.data);
        }
      });
    },
  },
  components: {
    Multiselect,
  },
};
</script>
<style lang="scss">
.el-radio {
  margin-bottom: 0;
}
</style>
